import { setLocale } from "yup";
import { i18n } from "./i18n";
export const setDefaultYupTranslations = () => setLocale({
    mixed: {
        default: i18n.t("common:validation.invalidField"),
        notType: ({ type }) => type === "number"
            ? i18n.t("common:validation.errorNumbersOnly")
            : i18n.t("common:validation.wrongType", { type }),
        required: i18n.t("common:validation.isRequired"),
    },
    number: {
        integer: i18n.t("common:validation.errorIntegersOnly"),
        lessThan: ({ less }) => i18n.t("common:validation.outOfRangeMax", { max: less }),
        max: ({ max }) => i18n.t("common:validation.outOfRangeMax", { max: max + 1 }),
        min: ({ min }) => i18n.t("common:validation.outOfRangeMin", { min: min - 1 }),
        moreThan: ({ more }) => i18n.t("common:validation.outOfRangeMin", { min: more }),
        negative: i18n.t("common:validation.negativeNumber"),
        positive: i18n.t("common:validation.positiveNumber"),
    },
    string: {
        email: i18n.t("common:validation.invalidEmail"),
        length: ({ length }) => i18n.t("common:validation.exactLength", { exactLength: length }),
        matches: ({ regex }) => i18n.t("common:validation.noMatch", { regex }),
        max: ({ max }) => i18n.t("common:validation.maxLength", { maxLength: max }),
        min: ({ min }) => i18n.t("common:validation.minLength", { minLength: min }),
        url: i18n.t("common:validation.invalidUrl"),
    },
});
//# sourceMappingURL=setDefaultYupTranslations.js.map